import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {onMounted, ref} from "vue";
import {ApiMap} from "@/api/type";
import {useApi} from "@/api/handler";
import {classes} from "@/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClassSelect',
  emits: ['change', 'submit'],
  setup(__props, { emit: __emit }) {

const classList = ref<ApiMap['/class/list']['resp'] | null>(null)
const selectedClass = ref<number | null>(null)

const emits = __emit

onMounted(() => {
  useClassList()
})

const useClassList = () => {
  useApi({
    api: classes.ClassList(0, 50, ''),
    onSuccess: resp => {
      classList.value = resp.data as ApiMap['/class/list']['resp']
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_select, {
      placeholder: "请选择班级",
      "max-width": "300",
      density: "compact",
      rounded: "",
      items: classList.value ? classList.value.list : [],
      "item-title": "classCode",
      "item-value": "id",
      variant: "outlined",
      modelValue: selectedClass.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((selectedClass).value = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (emits('change', selectedClass.value)))
      ]
    }, null, 8, ["items", "modelValue"]),
    _createVNode(_component_v_btn, {
      color: "indigo-lighten-1",
      rounded: "",
      "prepend-icon": "mdi-plus",
      class: "ml-4",
      style: {"margin-top":"2px"},
      onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('submit', selectedClass.value)))
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [
        _createTextVNode("新增游戏")
      ])),
      _: 1,
      __: [3]
    })
  ], 64))
}
}

})